import { useContext, useEffect, useState } from "react";
import { GET_ALL_NRIS_TALK_LIST, fetchData } from "../../../components/Service";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../../components/Context";
import _ from "lodash";
import moment from "../../../../node_modules/moment/moment";

const NrisTalk = () => {
	const [nrisTalk, setNrisTalk] = useState([]);
	const [context] = useContext(Context);

	const getForum = (country_id, state_id) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
		};
		fetchData(GET_ALL_NRIS_TALK_LIST + "?page=1", "POST", payload, false, false, (res) => {
			if (res.status) {
				setNrisTalk(res?.data?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		if (context?.countryId && context?.stateId) {
			getForum(context?.countryId, context?.stateId);
		}
	}, [context]);
	return (
		<div class="col-xl-4 col-lg-4 mb-1">
			<div class="card card-forum h-100">
				<div class="card-header usa-bg">
					<div className="national-bg">
						<h4 class="text-white d-flex ind1">NRIS Talk</h4>
					</div>
				</div>
				{/* <div class="card-header usa-bg">
					<h4 class="text-white d-flex">
						<span class="fw-light">NRIS </span> Talk
					</h4>
				</div> */}
				<div class="card-body bg-white news_scroll p-1">
					<div class="table-responsive fixtable">
						<table class="table table-borderless table-sm align-middle ">
							<thead>
								<tr className="table-light">
									<th>Title</th>
									<th>Created At</th>
									<th>
										<i class="fi fi-rs-comment-dots" title="Comments"></i>{" "}
									</th>
									<th>
										<i class="fi fi-rr-eye" title="Views"></i>{" "}
									</th>
								</tr>
							</thead>
							<tbody>
								{nrisTalk?.slice(0, 10)?.map((item) => (
									<tr key={item.id}>
										<td>
											<Link to={`/nri-talks/${item.id}`}>{_.truncate(item.title, { length: 35 })}</Link>
										</td>
										<td class="fw-light text-nowrap">{item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : ""}</td>
										<td>{item.comments_count ? item.comments_count : "0"}</td>
										<td>{item.nris_talk_count ? item.nris_talk_count : "0"}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div class="card-footer text-end py-1">
					<span class="font16 fw-normal ms-auto">
						<Link to={`/nri-talks`} class="text-decoration-underline font11">
							{" "}
							View More
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default NrisTalk;
